/** Coordinate helpers are pure so they can be verified without a browser. */
export function normalizeAngle(angle) {
  return ((angle % 360) + 360) % 360;
}

/** Convert margins as perceived by a viewer to the PDF's unrotated box edges. */
export function marginsToPdfEdges(margins, rotation) {
  const { left, right, top, bottom } = margins;
  switch (normalizeAngle(rotation)) {
    case 90: return { left: top, right: bottom, top: right, bottom: left };
    case 180: return { left: right, right: left, top: bottom, bottom: top };
    case 270: return { left: bottom, right: top, top: left, bottom: right };
    default: return { left, right, top, bottom };
  }
}

/** An image's bottom-left PDF origin, positioned around a clicked *visual* center.
 *  The viewer rotates the page clockwise; image content needs a CCW rotation
 *  to remain upright on screen. Rotation must be 0/90/180/270 degrees. */
export function imageOrigin(center, width, height, rotation) {
  const angle = normalizeAngle(rotation) * Math.PI / 180;
  const cos = Math.round(Math.cos(angle));
  const sin = Math.round(Math.sin(angle));
  return {
    x: center.x - (width / 2) * cos + (height / 2) * sin,
    y: center.y - (width / 2) * sin - (height / 2) * cos,
  };
}
